import React from 'react';
import styled from 'styled-components';
import { useChallengesState } from 'hooks/useChallengesState';
import { CHALLENGE_STATUS } from 'pages/dashboard/challenges/state/constants';

const ChallengeMetrics = ({ categoryId, instanceId }) => {
  const { state } = useChallengesState();
  
  // Replace draft lookup with instance status check
  const instance = state.challenges.instances[instanceId];
  const isDraft = instance?.status === CHALLENGE_STATUS.DRAFT;
  const opportunities = isDraft ? instance?.data?.opportunities || [] : [];
  const risks = isDraft ? instance?.data?.risks || [] : [];
  
  // Find active opportunity and risk
  const activeOpportunity = opportunities.find(item => item.isActive);
  const activeRisk = risks.find(item => item.isActive);
  
  // Calculate counts
  const opportunityCount = activeOpportunity ? (activeOpportunity.actions?.length || 0) : 0;
  const riskCount = activeRisk ? (activeRisk.actions?.length || 0) : 0;

  return (
    <MetricsContainer>
      <Metric
        data-tooltip={
          activeOpportunity
            ? `${opportunityCount} actions for "${activeOpportunity.content}"`
            : 'Select an opportunity to see its actions'
        }
        $hasItems={opportunities.length > 0}
      >
        <MetricValue>{opportunityCount}</MetricValue>
        <MetricLabel>{`Opportunity ${opportunityCount === 1 ? 'Action' : 'Actions'}`}</MetricLabel>
      </Metric>
      <Metric
        data-tooltip={
          activeRisk
            ? `${riskCount} actions for "${activeRisk.content}"`
            : 'Select a risk to see its actions'
        }
        $hasItems={risks.length > 0}
      >
        <MetricValue>{riskCount}</MetricValue>
        <MetricLabel>{`Risk ${riskCount === 1 ? 'Action' : 'Actions'}`}</MetricLabel>
      </Metric>
    </MetricsContainer>
  );
};

const MetricsContainer = styled.div.attrs({
  className: 'ChallengeMetrics'
})`
  display: flex;
  gap: 5px;
  margin-left: auto;
`;

const Metric = styled.div.attrs({
  className: 'Metric'
})`  
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-items: center;
  gap: 5px;
  max-width: 100px;
  position: relative;
  cursor: ${props => props.$hasItems ? 'pointer' : 'default'};
  padding: 3px 0px 3px 5px;
  border-radius: 3px;
  &:last-child {
    max-width: 65px;
    padding: 3px 5px 3px 5px;
  }
  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
  &:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 10px;
    background: #333;
    color: white;
    border-radius: 4px;
    font-size: 11px;
    white-space: nowrap;
    margin-top: 5px;
    z-index: 10;
  }
  &:hover::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #333 transparent;
    margin-top: -5px;
    z-index: 10;
  }
`;

const MetricLabel = styled.div.attrs({
  className: 'MetricLabel'
})`
  font-size: 12px;
  color: #B2BEB5;
  &:hover {
    color: white;
  }
`;

const MetricValue = styled.div.attrs({
  className: 'MetricValue'
})`
  font-size: 13px;
  font-weight: 600;
  background: #627b88;
  padding: 2px 6px;
  border-radius: 25px;
`;

export default ChallengeMetrics;